import { render, staticRenderFns } from "./WorldMap.vue?vue&type=template&id=608098a1&"
import script from "./WorldMap.vue?vue&type=script&lang=js&"
export * from "./WorldMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports